import React from 'react';
import { text } from 'components/common/Text';

export default function About() {
  return (
    <> 
      <div className="color-dark-grey font-btn" style={{ lineHeight: '1.6' }}>
        <p className="my-3">{text('login.about.app_support')}</p>
        <p className="my-3">{text('login.about.lpo_support')}</p>
        <p className="my-3">{text('login.about.site_support')}</p>
        <p className="my-3">{text('login.about.help_topics_support')}</p>
      </div>
    </>
  );
}